
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class EnrolledStudentDetailForm extends Form {
	private static _instance = new EnrolledStudentDetailForm();

	public static getInstance(): EnrolledStudentDetailForm {
		return EnrolledStudentDetailForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {get: true, filter: true};
	}

	public getName(): string {
		 return 'enrolledStudentDetail';
	}
}


export class EnrolledStudentDetailFd extends FormData {
	constructor(form: EnrolledStudentDetailForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface EnrolledStudentDetailVo extends Vo {
	registeredCredits?: number, 
	degreeId?: number, 
	levelSectionId?: number, 
	obtainedCredits?: number, 
	levelName?: string, 
	studentId?: number, 
	sectionName?: string, 
	sgpa?: number, 
	usn?: string, 
	totalCredits?: number, 
	seasonId?: number, 
	programName?: string, 
	levelId?: number, 
	name?: string, 
	instituteId?: number, 
	cgpa?: number, 
	admissionQuota?: string, 
	barcode?: number, 
	programId?: number
}
